import { COMPONENT_TYPE } from "@src/tracking/constant";
import { TPWAActivated, PWA_EVENTS } from ".";
import { trackByEvent } from "@src/tracking/services";
import i18n, { defaultLang } from '@src/i18n';
export const trackPWAIsActivated = (country : string) => {
    try {
        const { component_name, component_type, event, pagePWA } = PWA_EVENTS.PWA_ACTIVATED
        const trackData: TPWAActivated = {
            component_name,
            component_type: component_type as COMPONENT_TYPE,
            eventCategory: '',
            language: i18n.language || defaultLang,
            country,
            pagePWA
        }
        trackByEvent<TPWAActivated>(event, trackData)
    } catch (error) {
        console.log('trackPWAIsActivated error', error);
    }
}
